/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PaymentMethodInfo interface.
 */
export function instanceOfPaymentMethodInfo(value) {
    if (!('available' in value) || value['available'] === undefined)
        return false;
    if (!('fallbackable' in value) || value['fallbackable'] === undefined)
        return false;
    if (!('methodId' in value) || value['methodId'] === undefined)
        return false;
    if (!('providerId' in value) || value['providerId'] === undefined)
        return false;
    return true;
}
export function PaymentMethodInfoFromJSON(json) {
    return PaymentMethodInfoFromJSONTyped(json, false);
}
export function PaymentMethodInfoFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'available': json['available'],
        'fallbackable': json['fallbackable'],
        'methodId': json['method_id'],
        'providerId': json['provider_id'],
    };
}
export function PaymentMethodInfoToJSON(json) {
    return PaymentMethodInfoToJSONTyped(json, false);
}
export function PaymentMethodInfoToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'available': value['available'],
        'fallbackable': value['fallbackable'],
        'method_id': value['methodId'],
        'provider_id': value['providerId'],
    };
}
